import AppStoreLogo from "images/AppStoreLogo"
import PlayStoreLogo from "images/PlayStoreLogo"
import React from "react"
import { Box, Flex, Text } from "theme-ui"


const Footer = () => {

  return (
    <Box
      as={'footer'}
      sx={{
        position: "fixed",
        left: 0,
        bottom: 0,
        backgroundColor: "#eff1ff",
        width: "100%",
        padding: "20px",
        marginTop: "6rem",
        "@media screen and (min-width: 768px)": {
          display: "none",
        },
      }}
    >
      <Text sx={{ fontSize: "25px", fontWeight: "bold", color: " #191B4B" }}>
        Download to Get Started
      </Text>
      <Flex sx={{ justifyContent: "space-evenly", marginTop: "1rem" }}>
        <AppStoreLogo />

        <PlayStoreLogo />
      </Flex>
    </Box>
  )
}

export default Footer